<div mat-dialog-title>
  <span>{{ 'POPUPS.SWITCH_THEME' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">{{ error | translate }}</q9-info-message>

<mat-dialog-content class="dialog-content">
  <q9-info-message class="modal-info-message">
    {{ 'POPUPS.THEME_NOT_UNDOABLE' | translate }}
  </q9-info-message>
  <form [formGroup]="form" class="form-content">
    <mat-radio-group class="radio-group" formControlName="radio">
      <mat-radio-button color="primary" class="radio-group__button" [value]="changeScope.DIAGRAM">
        {{ 'POPUPS.THEME_ONLY_DIAGRAM' | translate }}
      </mat-radio-button>
      <mat-radio-button color="primary" class="radio-group__button" [value]="changeScope.CHILDREN">
        {{ 'POPUPS.THEME_DIAGRAM_AND_LOWER' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button [isLoading]="isLoading()" (click)="applyTheme()">
    {{ 'POPUPS.SWITCH_THEME' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
